import capitalize from "lodash/capitalize";

import { Category } from "~/models/dto";

import { Api, type EventCategory } from "../../../common/openapi";

export const toHumanReadableEventCategory = (category: EventCategory): string => capitalize(category);

export const toEventCategory = (category: Category): EventCategory => {
	switch (category) {
		case Category.Changes:
			return Api.EventCategory.Changes;
		case Category.Deployments:
			return Api.EventCategory.Deployments;
		case Category.Anomalies:
			return Api.EventCategory.Anomalies;
		case Category.Activities:
			return Api.EventCategory.Activities;
		case Category.Alerts:
			return Api.EventCategory.Alerts;
		default:
			return Api.EventCategory.Others;
	}
};
